import { statesGlob } from "./states";

const rootArea = "/types";

type REPORTING_TYPE = "POSITIVE" | "NEGATIVE"

export const typesGlob = (base: string) => (type?: REPORTING_TYPE) => ({
	read: `${base}${rootArea}/read`,
	states: statesGlob(`${base}${rootArea}/${type}`)
});
